import Cookies from 'js-cookie';
const VIEW_AS_USER_KEY = 'view_as';
export function setCurrentViewAsUserId(value) {
  Cookies.set(VIEW_AS_USER_KEY, value, { sameSite: 'Strict', secure: true });
}
export function removeCurrentViewAsUserId() {
  Cookies.remove(VIEW_AS_USER_KEY);
}
